module.exports = __webpack_public_path__ + "static/media/tube.234521c6.svg";